import { generateRandomPassword, throwError } from "../common/commonFunctions";
import {
  backend_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";

export const declineUser = async (id, declinedReason) => {
  try {
    let params = {
      confirmed: false,
      declined: true,
      declinedReason,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "users/" + id,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const updateUserProfileImage = async (id, profileImage) => {
  try {
    let params = {
      profileImage,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `users/${id}`,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
    };
  }
};

export const updateUserLanguage = async (id, language = "English") => {
  try {
    let params = {
      language,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "users/" + id,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const updateUser = async (
  id,
  role,
  username,
  email,
  teams,
  firstName,
  lastName,
  supervisor,
  locations,
  phone,
  profileImage,
  organisation,
  userProfile
) => {
  try {
    let params = {
      role,
      email,
      username,
      teams,
      firstName,
      lastName,
      supervisor,
      locations,
      phone,
      profileImage,
      organisation,
      userProfile,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "users/" + id,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    throw throwError({
      message: err.response?.data?.error?.message,
    });
  }
};

export const updateUserRole = async (role, id, organisation) => {
  try {
    let params = {
      role,
      organisation,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "users/" + id,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getUserSignature = async () => {
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + "user-profile/signature"
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const createNewUserProfile = async (
  user,
  phone,
  address,
  emergencyName,
  emergencyPhone,
  educationLevel,
  fieldOfStudy,
  martialStatus,
  nationality,
  passportNo,
  identificationNo,
  dob,
  cob,
  gender,
  childrenNo,
  visaNo,
  visaExpireDate,
  jobTitle,
  department,
  hourRate,
  whpd,
  whpw,
  contractStart,
  contractEnd,
  registrationNo,
  badgeId,
  shifts,
  workPermitNo,
  days,
  contractCopy,
  idCopyFront,
  personalPicture,
  passportCopy,
  visaCopy,
  covidCopy
) => {
  try {
    let params = {
      user,
      phone,
      address,
      emergencyName,
      emergencyPhone,
      educationLevel,
      fieldOfStudy,
      martialStatus,
      nationality,
      passportNo,
      identificationNo,
      dob,
      cob,
      gender,
      childrenNo,
      visaNo,
      visaExpireDate,
      job: jobTitle,
      department,
      hourRate,
      whpd,
      whpw,
      contractStart,
      contractEnd,
      registrationNo,
      badgeId,
      shifts,
      workPermitNo,
      days,
    };

    if (contractCopy)
      params = {
        ...params,
        contractCopy,
      };
    if (idCopyFront)
      params = {
        ...params,
        idCopyFront,
      };

    if (personalPicture)
      params = {
        ...params,
        personalPicture,
      };

    if (passportCopy)
      params = {
        ...params,
        passportCopy,
      };

    if (visaCopy)
      params = {
        ...params,
        visaCopy,
      };

    if (covidCopy)
      params = {
        ...params,
        covidCopy,
      };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "user-profiles",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    return response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const verifyPersonEmailAndPhone = async (
  id,
  email,
  phone,
  organisation,
  role
) => {
  try {
    let params = {
      role: role,
      username: "",
      email: email,
      teams: [],
      firstName: "",
      lastName: "",
      supervisor: null,
      locations: [],
      userId: id,
      phone: phone,
      password: "",
      organisation: organisation,
      createdByUser: null,
    };
    const response = await uninterceptedAxiosInstance.post(
      backend_url + `auth/verify/phone-email`,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const createNewUser = async (
  username,
  role,
  phone,
  email,
  teams,
  firstName,
  lastName,
  supervisor,
  locations,
  organisation = "",
  createdByUser = null,
  profileImage
) => {
  try {
    const password = generateRandomPassword(8);

    const params = {
      username,
      role,
      phone,
      email,
      teams,
      firstName,
      lastName,
      supervisor,
      locations,
      password,
      organisation,
      createdByUser,
      profileImage,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "auth/local/register",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    return response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    throw throwError({
      message: err.response?.data?.error?.message,
    });
  }
};

export const approveUser = async (id) => {
  try {
    let params = {
      confirmed: true,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "users/" + id,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const deleteUser = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "users/removeUsers",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const addUserSignature = async (ID) => {
  try {
    let params = {
      data: {
        signature: [ID],
      },
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "user-profile/signature",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err.response?.data?.error,
    };
  }
};

export const deleteUserSignature = async (ID) => {
  try {
    const response = await uninterceptedAxiosInstance.post(
      backend_url + `user-profile/signature/remove/${ID}`,
      null,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err.response?.data?.error,
    };
  }
};

export const DeactivatePeople = async (
  status = "",
  userId = null,
  reassignedUserId = null
) => {
  try {
    const params = {
      status,
      userId,
      reassignedUserId,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "users/update/status",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    return response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const updateUserProfile = async (
  id,
  phone,
  address,
  emergencyName,
  emergencyPhone,
  educationLevel,
  fieldOfStudy,
  martialStatus,
  nationality,
  passportNo,
  identificationNo,
  dob,
  cob,
  gender,
  childrenNo,
  visaNo,
  visaExpireDate,
  jobTitle,
  department,
  hourRate,
  whpd,
  whpw,
  contractStart,
  contractEnd,
  registrationNo,
  badgeId,
  shifts,
  workPermitNo,
  days,
  contractCopy,
  idCopyFront,
  personalPicture,
  passportCopy,
  visaCopy,
  covidCopy
) => {
  try {
    let params = {
      phone,
      address,
      emergencyName,
      emergencyPhone,
      educationLevel,
      fieldOfStudy,
      martialStatus,
      nationality,
      passportNo,
      identificationNo,
      dob,
      cob,
      gender,
      childrenNo,
      visaNo,
      visaExpireDate,
      job: jobTitle ? jobTitle : null,
      department,
      hourRate,
      whpd,
      whpw,
      contractStart,
      contractEnd,
      registrationNo,
      badgeId,
      shifts,
      workPermitNo,
      days,
      passportCopy,
      idCopyFront,
      personalPicture,
      visaCopy,
      covidCopy,
      contractCopy,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "user-profiles/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    return response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
